import React from 'react';

/**
 * Simple Token Display Component - Shows tokens as emojis only
 * Visual indicator emulating physical tokens placed on cards
 */
const SimpleTokenDisplay = ({
  current = 0,
  maximum = 0,
  size = 'small',
  showEmpty = false,
  type = 'token' // 'token' for 🪙 or 'dice' for 🎲
}) => {
  if (maximum === 0) return null;

  const getSizeClasses = () => {
    switch (size) {
      case 'tiny':
        return 'text-sm';
      case 'small':
        return 'text-base';
      case 'normal':
        return 'text-lg';
      default:
        return 'text-base';
    }
  };

  const sizeClass = getSizeClasses();

  // Choose emoji based on type
  const emoji = type === 'dice' ? '🎲' : '🪙';

  // Generate array of token emojis - show current tokens and empty slots if needed
  const tokens = [];

  // Add current (available) tokens
  for (let i = 0; i < current; i++) {
    tokens.push(
      <span
        key={`current-${i}`}
        className={sizeClass}
        title={`${type === 'dice' ? 'Die' : 'Token'} ${i + 1} (available)`}
      >
        {emoji}
      </span>
    );
  }

  // Add empty token slots if showEmpty is true
  if (showEmpty && current < maximum) {
    for (let i = current; i < maximum; i++) {
      tokens.push(
        <span
          key={`empty-${i}`}
          className={`${sizeClass} filter brightness-25 opacity-50`}
          title={`${type === 'dice' ? 'Die' : 'Token'} ${i + 1} (spent/empty)`}
        >
          {emoji}
        </span>
      );
    }
  }

  // Show something if we have current tokens OR if we're supposed to show empty slots
  if (current === 0 && !showEmpty) return null;

  return (
    <div className="flex items-center gap-0.5">
      {tokens}
    </div>
  );
};

export default SimpleTokenDisplay;